import { render, staticRenderFns } from "./TaskInfoRequestsSection.vue?vue&type=template&id=dbdc6152&scoped=true"
import script from "./TaskInfoRequestsSection.vue?vue&type=script&lang=js"
export * from "./TaskInfoRequestsSection.vue?vue&type=script&lang=js"
import style0 from "./TaskInfoRequestsSection.vue?vue&type=style&index=0&id=dbdc6152&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbdc6152",
  null
  
)

export default component.exports